import React from 'react';

export const ImageDialog = props => (
  <div
    className='dialog-sm dialog--modal'
    onClick={e => {
      e.stopPropagation();
    }}
  >
    <div className='dialog-sm__header'>
      <span className='dialog-sm__title'>登録失敗</span>
    </div>
    <div className='dialog-sm__body'>
      <p>
        <span className='text--muted'>{props.dialog.message}</span>
      </p>
    </div>
    <div className='dialog-sm__footer'>
      <button
        className='btn--sub'
        onClick={e => props.dialog.callback.confirm(e)}
      >
        了解
      </button>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/modals/ImageDialog.jsx